import { TheWestSection } from '@news-mono/common'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { getSwgLandingPage } from '../regionals/get-swg-landing-page'

const createIntro25OfferPage: StaticRoute<TheWestSection> = (services) => {
    if (!services.store.getState().toggles['intro-25-google-offer']) return null
    return getSwgLandingPage({
        section: 'default',
        getAdTargeting: services.getAdTargeting,
        toggles: services.store.getState().toggles,
        logger: services.log,
        options: {
            modifier: 'intro-25-offer',
            noIndex: true,
            desiredRedirect: `${services.protocol}//${services.hostname}`,
        },
    })
}

export const getIntro25OfferRouteInfo: StaticRoutes<TheWestSection> = {
    '/googleintrooffer': createIntro25OfferPage,
}
